// src/redux/Types.js

export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN';
export const REMOVE_AUTH_TOKEN = 'REMOVE_AUTH_TOKEN';
export const SET_LOGGED_IN = 'SET_LOGGED_IN';
